export default "__VITE_ASSET__B3mgygr4__"